module.exports = __webpack_public_path__ + "static/media/297456.dd2c15e0.png";